import { createStrictContext } from '@apeiron/temp'
import { ComponentBlock } from '@src/constants/componentBlock'
import { ReactChild } from 'react'

const [ContextProvider, useComponentBlockerContext] =
  createStrictContext<ContextProps>('ComponentBlocker', { blockKeys: [] })

export { useComponentBlockerContext }

export const ComponentBlockerProvider = (props: Props) => {
  const { children, blockKeys } = props

  return <ContextProvider value={{ blockKeys }}>{children}</ContextProvider>
}

type ContextProps = {
  blockKeys: ComponentBlock[]
}

type Props = {
  children: ReactChild | ReactChild[]
  blockKeys: ComponentBlock[]
}
